import { atom } from 'jotai'
import { Config } from './newConfigAtoms';

// 新規作成フォームの「既存計算セットから複製」ダイアログ専用の参照元 Config。
// DataRegistration のコピー機能（copyFromConfigAtoms）とは別 state とし、2 機能を
// in-memory state 経由で結合させない。計算セット段（calculation_id）までを辿る
// ピッカー用途のため condition / phenomenon / drive は持たない。
export const referenceConfigAtom = atom<Config>({
    project_id: '',
    destination_id: '',
    lot_id: '',
    phase_id: '',
    unit_id: '',
    calculation_id: '',
    condition_id: '',
    graph_id: '',
});

// 親段を選び直したら下位段をクリアするカスケード field atoms（copyFromConfigAtoms と同型）。
export const projectIdAtom = atom(
    (get) => get(referenceConfigAtom).project_id,
    (get, set, newProjectId: string) => {
        set(referenceConfigAtom, {
            ...get(referenceConfigAtom),
            project_id: newProjectId,
            destination_id: '',
            lot_id: '',
            phase_id: '',
            unit_id: '',
            calculation_id: '',
        })
    }
);

export const destinationIdAtom = atom(
    (get) => get(referenceConfigAtom).destination_id,
    (get, set, newDestinationId: string) => {
        set(referenceConfigAtom, {
            ...get(referenceConfigAtom),
            destination_id: newDestinationId,
            lot_id: '',
            phase_id: '',
            unit_id: '',
            calculation_id: '',
        })
    }
);

export const lotIdAtom = atom(
    (get) => get(referenceConfigAtom).lot_id,
    (get, set, newLotId: string) => {
        set(referenceConfigAtom, {
            ...get(referenceConfigAtom),
            lot_id: newLotId,
            phase_id: '',
            unit_id: '',
            calculation_id: '',
        })
    }
);

export const phaseIdAtom = atom(
    (get) => get(referenceConfigAtom).phase_id,
    (get, set, newPhaseId: string) => {
        set(referenceConfigAtom, {
            ...get(referenceConfigAtom),
            phase_id: newPhaseId,
            unit_id: '',
            calculation_id: '',
        })
    }
);

export const unitIdAtom = atom(
    (get) => get(referenceConfigAtom).unit_id,
    (get, set, newUnitId: string) => {
        set(referenceConfigAtom, {
            ...get(referenceConfigAtom),
            unit_id: newUnitId,
            calculation_id: '',
        })
    }
);

export const calculationIdAtom = atom(
    (get) => get(referenceConfigAtom).calculation_id,
    (get, set, newCalculationId: string) => {
        set(referenceConfigAtom, {
            ...get(referenceConfigAtom),
            calculation_id: newCalculationId,
        })
    }
);
